import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchTestimonials,
  fetchTestimonialsSuccess,
  fetchTestimonialsFailure,
} from "../slices/testimonialSlice";

const fetchTestimonialsAPI = async () => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/v1/testimonial`);

  if (!res.ok) throw new Error("Fetch failed");

  const result = await res.json();
  return result;
};

function* handleFetchTestimonials() {
  try {
    const result = yield call(fetchTestimonialsAPI);

    if (result.success && Array.isArray(result.data)) {
      yield put(fetchTestimonialsSuccess(result.data));
    } else {
      yield put(fetchTestimonialsFailure("Failed to load testimonials"));
    }
  } catch (error) {
    yield put(fetchTestimonialsFailure(error.message));
  }
}

export function* watchTestimonialSaga() {
  yield takeLatest(fetchTestimonials.type, handleFetchTestimonials);
}
